import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "css-reference"
    }}>{`CSS Reference`}</h1>
    <p>{`Technical documentation regarding the kinds of CSS styles and features available in UXP.`}</p>
    <h2 {...{
      "id": "pages-in-this-section"
    }}>{`Pages in this section`}</h2>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "General/index.md"
        }}>{`General`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "Media%20Queries/index.md"
        }}>{`Media Queries`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "Pseudo-classes/index.md"
        }}>{`Pseudo-classes`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "Pseudo-elements/index.md"
        }}>{`Pseudo-elements`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "Selectors/index.md"
        }}>{`Selectors`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "Styles/index.md"
        }}>{`Styles`}</a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      